import { DeepMap, FieldError, get } from 'react-hook-form';

/** errors in React Hook Form have a pesky tendency to be typed as any.
 * This helper function gets the errors in a simple way, while correctly typing the error.
 */
export function getError(errors: DeepMap<Record<string, unknown>, FieldError>, name: string) {
  return get(errors, name) as FieldError | undefined;
}
